const SUMMARY_CLASS = "pr-rd-helpful-summary";

export function decorateHelpfulCounts(
	root: HTMLElement,
	formatLabel: (count: number) => string
): void {
	const groups = root.querySelectorAll<HTMLElement>(
		".pr-rd-helpful-action-group"
	);

	groups.forEach((group) => {
		const countEl = group.querySelector(
			".pr-helpful-yes .pr-helpful-count"
		);
		const flagContainer = group.querySelector<HTMLElement>(
			".pr-rd-flag-review-container"
		);
		if (!countEl || !flagContainer) return;

		const count = Number.parseInt(countEl.textContent?.trim() ?? "", 10);
		if (Number.isNaN(count)) return;

		const label = formatLabel(count);
		let summary = flagContainer.querySelector<HTMLParagraphElement>(
			`.${SUMMARY_CLASS}`
		);
		if (!summary) {
			summary = document.createElement("p");
			summary.className = SUMMARY_CLASS;
			flagContainer.insertBefore(summary, flagContainer.firstChild);
		}
		if (summary.textContent !== label) {
			summary.textContent = label;
		}
	});
}
